// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PlanPackagePageV2_PlanPackageFragmentDoc } from '../PlanPackagePageV2.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SavePlanPackageMutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type SavePlanPackageMutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, name: string, displayCode?: string | null | undefined, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, displayVersion: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string }, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, displayVersion: string, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, hasLocationProposals: boolean, hasOptionProposals: boolean, hasProgramDataProposals: boolean, hasElevationProposals: boolean } | null | undefined } } };


export const SavePlanPackageDocument = gql`
    mutation SavePlanPackage($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      ...PlanPackagePageV2_PlanPackage
    }
  }
}
    ${PlanPackagePageV2_PlanPackageFragmentDoc}`;

/**
 * __useSavePlanPackageMutation__
 *
 * To run a mutation, you first call `useSavePlanPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageMutation, { data, loading, error }] = useSavePlanPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageMutation, SavePlanPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageMutation, SavePlanPackageMutationVariables>(SavePlanPackageDocument, options);
      }
export type SavePlanPackageMutationHookResult = ReturnType<typeof useSavePlanPackageMutation>;
export type SavePlanPackageMutationResult = ApolloReactCommon.MutationResult<SavePlanPackageMutation>;